import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "size", "color"];
import unescapedText from 'I18n/utils/unescapedText';
import { View } from '../../../components/View/View';
import styled from 'foundations-theming/utils';
import { uniqueId } from '../../utils/uniqueId';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getLabel = use => {
  if (use === 'decrease') return unescapedText('salesUI.UIChangeArrow.decrease');
  if (use === 'increase') return unescapedText('salesUI.UIChangeArrow.increase');
  return undefined;
};
const StyledChangeArrow = styled.svg.withConfig({
  displayName: "ChangeArrow__StyledChangeArrow",
  componentId: "sc-979dww-0"
})(({
  $cssStyles,
  $use,
  theme,
  $size
}) => {
  return Object.assign({
    fontSize: $size,
    height: '0.625em',
    marginRight: theme.space['200'],
    width: '0.875em',
    color: $use === 'increase' ? theme.color['fill-positive-default'] : theme.color['fill-alert-default'],
    transform: $use === 'decrease' ? 'rotate(180deg)' : 'none'
  }, $cssStyles);
});
const ChangeArrowShape = styled.path.withConfig({
  displayName: "ChangeArrow__ChangeArrowShape",
  componentId: "sc-979dww-1"
})(["fill:currentColor;"]);
export const ChangeArrow = _ref => {
  let {
      use,
      size = '16px',
      color
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _id = uniqueId('change-arrow-');
  const label = getLabel(use);
  const {
    tokenProps
  } = filterProps({
    color
  });
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(View, Object.assign({}, rest, {
    as: "span",
    children: /*#__PURE__*/_jsxs(StyledChangeArrow, {
      $use: use,
      "aria-labelledby": _id,
      $size: size,
      $cssStyles: cssStyles,
      viewBox: "0 0 14 10",
      xmlns: "http://www.w3.org/2000/svg",
      role: "img",
      children: [/*#__PURE__*/_jsx("title", {
        id: _id,
        children: label
      }), /*#__PURE__*/_jsx(ChangeArrowShape, {
        d: "M0 9.63h14L7 0",
        fillRule: "evenodd"
      })]
    })
  }));
};